<script setup>
import Vapor from "laravel-vapor";
import BrandButton from "@/Components/Brand/BrandButton.vue";

const cards = [
    {
        eyebrow: "Add gifts while you browse",
        headline: "Your On-the-Go Smile Generator",
        body: "Easily add products to your Wish Lists from anywhere you shop online.",
        button: "Add Browser Extension",
        // Figma 1-796: the narrow card drops the verb and the glyph.
        buttonMobile: "Browser Extension",
        buttonIcon: Vapor.asset("images/brand/icon-extension.svg"),
        linkRoute: "browser-extensions",
        image: Vapor.asset("images/brand/cta-extension-card.webp"),
        float: Vapor.asset("images/brand/cta-smile-float.webp"),
        imageSide: "left",
        // Decoration cluster over the photo's top-left corner.
        floatPos: "-left-[4.6%] -top-[16.3%] w-[57.6%]",
    },
    {
        eyebrow: "Inspired gifts",
        headline: "Showers. Birthdays. Just Because.",
        body: "Easily add products to your Wish Lists from anywhere you shop online.",
        button: "Start a Wish List",
        buttonMobile: "Start a Wish List",
        buttonIcon: null,
        linkRoute: "register",
        image: Vapor.asset("images/brand/cta-showers-card.webp"),
        float: Vapor.asset("images/brand/cta-showers-float1.webp"),
        imageSide: "right",
        // Decoration cluster over the photo's top-right corner.
        floatPos: "-right-[1.5%] -top-[10.3%] w-[60.3%]",
    },
];
</script>

<template>
    <section class="px-5 py-8">
        <div class="mx-auto grid max-w-[1400px] gap-6 lg:grid-cols-2">
            <div
                v-for="card in cards"
                :key="card.headline"
                class="flex items-center gap-5 rounded-brand bg-white p-4 md:min-h-[358px] md:gap-8 md:p-[23px] lg:gap-6 xl:gap-14"
                :class="card.imageSide === 'right' ? 'flex-row-reverse' : ''"
            >
                <!-- Photo + decoration cluster -->
                <div
                    class="relative w-[38%] shrink-0 md:w-[262px] lg:w-[180px] xl:w-[262px]"
                >
                    <img
                        loading="lazy"
                        :src="card.image"
                        :alt="card.headline"
                        class="aspect-[134/200] w-full rounded-brand object-cover md:aspect-[262/312]"
                    />
                    <img
                        loading="lazy"
                        :src="card.float"
                        alt=""
                        aria-hidden="true"
                        class="pointer-events-none absolute"
                        :class="card.floatPos"
                    />
                </div>

                <!-- Copy: compact Figma mobile scale (11/20/11/13, node 1-782)
                     stepping up to the desktop treatment from md. -->
                <div class="min-w-0 max-w-[303px] flex-1">
                    <p
                        class="font-brand-display text-[11px] font-semibold italic uppercase leading-[0.9] tracking-wide text-[#b1a7a5] md:text-[16px]"
                    >
                        {{ card.eyebrow }}
                    </p>
                    <h3
                        class="mt-[6px] font-brand-display text-[20px] font-black italic uppercase leading-none tracking-tight text-brand-navy md:mt-[9px] md:text-[clamp(1.75rem,3.5vw,31px)]"
                    >
                        {{ card.headline }}
                    </h3>
                    <p
                        class="mt-3 font-brand text-[12px] leading-[1.35] text-brand-navy md:mt-[21px] md:text-[15px]"
                    >
                        {{ card.body }}
                    </p>

                    <!--
                        Mobile buttons are a fixed 44px (Figma 1-795 / 1-801) and
                        never wrap, so the two cards' CTAs stay the same height
                        however the label fits the narrow copy column (BH-32).
                    -->
                    <BrandButton
                        :href="route(card.linkRoute)"
                        :icon="card.buttonIcon"
                        icon-class="max-md:hidden"
                        class="mt-4 h-11 w-fit whitespace-nowrap px-5 text-[13px] md:mt-[26px] md:h-auto md:px-7 md:py-3.5 md:text-[15px]"
                    >
                        <span class="md:hidden">{{ card.buttonMobile }}</span>
                        <span class="max-md:hidden">{{ card.button }}</span>
                    </BrandButton>
                </div>
            </div>
        </div>
    </section>
</template>
